import { useOIORewriteContext } from "../providers/OIORewriteProvider"

export function useOIORewriteAgent() {
  return useOIORewriteContext()
}
